module.exports = __webpack_public_path__ + "0f65f4c4cea2682039117cd022a6ad69.svg";